// 英文
import enLocale from 'element-ui/lib/locale/lang/en'


const en = {
  // ============== 登陆页 start=============
  "登录": "Sign in",
  "退出": "Sign out",
  "账号": "Account",
  "密码": "Password",
  "验证码": "Verification code",
  "请输入账号": "Please enter your account",
  "请输入密码": "Please enter your password",
  "请输入验证码": "Please enter the verification code",
  "验证码不正确": "Incorrect verification code",
  "没有账号": "No account",
  "请": "Please",
  "点击注册": "Click to register",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Total Stores",
  "用户总量": "Overall User Count",
  "营业总量": "Total Business Turnover",
  "订单总量": "Total Order Volume",
  "商品总量": "Total Inventory Count",
  "销售总额": "Total Sales",
  "元": "€",
  "预计收入": "Estimated Income",
  "今日概况": "Today's Summary",
  "销售额": "Sales Volume",
  "支付订单数": "Paid orders",
  "昨日": "Yesterday",
  "新增用户数": "New Users",
  "新增商户": "New Merchants",
  "下单用户数": "Users Placing Orders",
  "待办事项": "Pending Tasks",
  "请尽快处理，以免影响营业": "Please address promptly to prevent business impact",
  "待处理订单": "Processing Orders ",
  "库存告急": "Inventory Emergency",
  "销量": "Volume of Sales",
  "暂无上榜记录": "No Ranking Records at Present",
  "成交额": "Transaction Volume.",
  "成交量": "Transaction Orders",
  "退单额": "Total Refunds Volume",
  "退单量": "Refunds Orders",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Basic Information",
  "编辑门店": "Edit Store",
  "官方网站": "Official Website",
  "门店服务": "Store Services",
  "服务与营业时间": "Services and Business Hours",
  "收银台": "Cash Register",
  "后厨": "Kitchen",
  "商品": "Goods",
  "添加商品": "Add Goods",
  "网站": "Website",
  "网站编辑": "Website Editing",
  "上一步": "Previous Step",
  "保存": "Save",
  "下一步": "Next Step",
  "提交失败": "Submission Failed",
  "获取当前进度信息失败": "Failed to Get Current Progress Information",
  "请输入门店名称": "Please Enter Store Name",
  "登录密码": "Login Password",
  "请输入登录密码": "Please Enter Login Password",
  "确认密码": "Confirm Password",
  "请输入确认密码": "Please Enter Confirm Password",
  "联系人": "Contact",
  "请输入联系人": "Please Enter Contact name",
  "请输入联系电话": "Please Enter Contact Phone Number",
  "店铺类型": "Store Type",
  "分店": "Branch",
  "直营": "Direct Sales",
  "商品分类": "Goods Classification",
  "同步主店": "Synchronize with Main Store",
  "分店创建": "Branch Creation",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Warm Reminder: After choosing, please do not modify it randomly to avoid confusing store goods data",
  "绑定用户": "Bind User",
  "选择用户": "Select User",
  "用户昵称": "Nickname",
  "门店logo": "Store Logo",
  "选择图片": "Select Picture",
  "地址": "Address",
  "请输入地址": "Please Enter Address",
  "门店坐标": "Store Coordinates",
  "商家介绍": "Merchant Introduction",
  "状态": "Status",
  "开启": "Open",
  "禁止": "Close",
  "营业状态": "Business Status",
  "营业中": "Open",
  "停止营业": "Closed",
  "上传图片": "Upload Picture",
  "获取当前门店失败，请刷新界面重试": "Failed to get the current store, please refresh the page and try again",
  "商城名称": "Mall Name",
  "商城名称不能为空": "Mall Name Cannot Be Empty",
  "访问网址后缀": "Access URL Suffix",
  "访问网址": "Visit URL",
  "手机网站": "Mobile Website",
  "默认": "Default",
  "自定义": "Custom",
  "Pad点餐网站": "Pad Ordering Website",
  "收银台网站": "Cashier Website",
  "后厨网站": "Kitchen Website",
  "会员设置": "Member Settings",
  "请选择默认头像": "Please Select Default Avatar",
  "门店二维码": "Store QR Code",
  "下载": "Download",
  "营业时间": "Business Hours",
  "店内营业时间": "In-Store Business Hours",
  "请选择店内营业时间": "Please Select In-Store Business Hours",
  "开始时间": "Start Time",
  "结束时间": "End Time",
  "选择时间范围": "Select Time Range",
  "自提营业时间": "Self-Pickup Business Hours",
  "请选择自提营业时间": "Please Select Self-Pickup Business Hours",
  "外卖营业时间": "Takeaway Business Hours",
  "请选择外卖营业时间": "Please Select Takeaway Business Hours",
  "外卖配送": "Takeaway Delivery",
  "注": "Note",
  "外卖配送方式至少选择一个": "At least one takeaway delivery method must be selected",
  "店内配置": "In-Store Configuration",
  "店内用餐方式至少选择一个": "At least one in-store dining method must be selected",
  "堂食服务": "Dine-In Service",
  "店内堂食结算模式": "In-Store Dine-In Settlement Mode",
  "先结账后用餐": "Pay First, Then Dine",
  "先用餐后结账": "Dine First, Then Pay",
  "收银台桌台清台设置": "Cashier Table Clearing Settings",
  "定时清台": "Timed Table Clearing",
  "立即清台": "Immediate Table Clearing",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "After turning on timed table clearing, the system will automatically clear the table of the cashier's ordering after the set time. This function only works in the pre-meal payment mode",
  "桌台订单清台设置": "Table Order Clearing Settings",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Automatically clean the table minutes later (scan the table code ordering and cashier table ordering timed table clearing time)",
  "店内堂食服务费": "In-Store Dine-In Service Charge",
  "按就餐人数收取": "Charge According to the Number of Diners",
  "按每桌台收取": "Charge Per Table",
  "请输入服务费": "Please Enter Service Charge",
  "位": "Seat",
  "桌": "Table",
  "店内包装费类型": "In-Store Packaging Fee Type",
  "按商品收费": "Charge According to Goods",
  "按单收费": "Charge Per Order",
  "包装费": "Packaging Fee",
  "请输入包装费": "Please Enter Packaging Fee",
  "外卖服务": "Takeaway Service",
  "外卖包装费类型": "Takeaway Packaging Fee Type",
  "外卖配送范围": "Takeaway Delivery Range",
  "请输入外卖配送范围": "Please Enter Takeaway Delivery Range",
  "外卖配送费": "Takeaway Delivery Fee",
  "请输入外卖配送费": "Please Enter Takeaway Delivery Fee",
  "最低消费": "Minimum Consumption",
  "请输入最低消费": "Please Enter Minimum Consumption",
  "桌码管理": "Table Code Management",
  "添加类型": "Add Type",
  "类型名称": "Type Name",
  "删除": "Delete",
  "桌位管理": "Table Management",
  "最少人数": "Minimum Number of People",
  "最多人数": "Maximum Number of People",
  "取 消": "Cancel",
  "确 定": "Confirm",
  "请输入类型名称": "Please Enter Type Name",
  "排序不能为空": "Sorting Cannot Be Empty",
  "排序必须为数字": "Sorting Must Be a Number",
  "添加成功": "Added Successfully",
  "修改类型": "Modify Type",
  "修改成功": "Modified Successfully",
  "添加区域": "Add Area",
  "区域名称": "Area Name",
  "修改区域": "Modify Area",
  "请输入区域名称": "Please Enter Area Name",
  "分类名称": "Category Name",
  "编号": "Number",
  "选择区域": "Select Area",
  "请选择": "Please Select",
  "选择类型": "Select Type",
  "桌号id": "Table ID",
  "所属区域": "Belonging Area",
  "桌位类型": "Table Type",
  "桌位编码": "Table Code",
  "人数区间": "Number of People Range",
  "人": "People",
  "二维码": "QR Code",
  "桌位编号": "Table Number",
  "请输入桌位编号": "Please Enter Table Number",
  "请选择类型名称": "Please Select Type Name",
  "请选择所属区域": "Please Select Belonging Area",
  "添加桌位": "Add Table",
  "关键词": "Keyword",
  "添加收银员": "Add Cashier",
  "姓名": "Name",
  "登录账号": "Login Account",
  "联系方式": "Contact Method",
  "收银员管理": "Cashier Management",
  "编辑": "Edit",
  "手机号": "Mobile Number",
  "请输入登录账号": "Please Enter Login Account",
  "长度在6到16个字符": "Length between 6 to 16 characters",
  "两次输入密码不一致！": "The two passwords entered are not consistent!",
  "禁用": "Disable",
  "删除后不可恢复，确认删除该记录吗?": "Cannot be recovered after deletion, confirm to delete this record?",
  "提示": "Prompt",
  "后厨人员管理": "Kitchen Staff Management",
  "添加后厨人员": "Add Kitchen Staff",
  "添加后厨账号": "Add Kitchen Account",
  "普通分类": "General Classification",
  "添加分类": "Add Category",
  "图片": "Picture",
  "分类排序": "Category Sorting",
  "税率设置": "Tax Rate Setting",
  "添加税率": "Add Tax Rate",
  "税率分类名称": "Tax Rate Category Name",
  "税率": "Tax Rate",
  "适用于菜品分类": "Applicable to Dish Classification",
  "未找到相应数据": "No Corresponding Data Found",
  "请输入分类名称": "Please Enter Category Name",
  "分类排序不能为空": "Category Sorting Cannot Be Empty",
  "分类排序必须为数字": "Category Sorting Must Be a Number",
  "正在翻译，请稍后": "Translating, please wait",
  "多语言翻译": "Multilingual Translation",
  "修改分类": "Modify Category",
  "翻译": "Translation",
  "分类图片": "Category Picture",
  "外卖商品": "Takeaway Goods",
  "店内商品": "In-Store Goods",
  "商品管理": "Goods Management",
  "分类管理": "Category Management",
  "上架中": "On Sale",
  "下架": "Off Shelf",
  "商品名称": "Goods Name",
  "请输入商品名称": "Please Enter Goods Name",
  "添加产品": "Add Product",
  "产品": "Product",
  "实际销量": "Actual Sales",
  "库存": "Inventory",
  "发布时间": "Release Time",
  "销售价": "Sale Price",
  "下架中": "Off Shelf",
  "强制下架": "Force Off Shelf",
  "重新上架": "Re-On Shelf",
  "上架": "On Shelf",
  "确认要": "Confirm to",
  "成功": "Success",
  "删除成功": "Delete Successfully",
  "请先选择一个选项": "Please Select an Option First",
  "正在完成翻译，请稍后操作": "Completing Translation, Please Operate Later",
  "请检查表单的必填项是否全部填写": "Please Check Whether All Required Items in the Form Are Filled",
  "补全成功": "Completion Successful",
  "主语言选择": "Main Language Selection",
  "请选择主语言": "Please Select Main Language",
  "高级设置": "Advanced Settings",
  "取消": "Cancel",
  "修改": "Modify",
  "保存成功": "Save Successfully",
  "规格": "Specification",
  "库存计算方式": "Inventory Calculation Method",
  "下单减库存": "Order to Reduce Inventory",
  "特色分类": "Featured Classification",
  "产品规格": "Product Specification",
  "单规格": "Single Specification",
  "多规格": "Multiple Specifications",
  "此商品正在参加活动，不能修改规格": "This product is participating in an activity and cannot modify the specification",
  "AI魔法创建": "AI Magic Creation",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Through artificial intelligence technology, you can automatically fill in detailed information about the product based on the product name, such as ingredients, selling points, taste, etc.",
  "所属分类": "Belonging Category",
  "请选择商品分类": "Please Select Product Category",
  "请填写商品详情": "Please Fill in Product Details",
  "商品详情": "Product Details",
  "换一换": "Change",
  "产品价格": "Product Price",
  "请填写产品价格": "Please Fill in Product Price",
  "请填写包装费": "Please Fill in Packaging Fee",
  "规格明细": "Specification Details",
  "规格名称": "Specification Name",
  "请输入内容": "Please Enter Content",
  "价格": "Price",
  "添加规格": "Add Specification",
  "商品图片": "Product Picture",
  "请上传商品图片": "Please Upload Product Picture",
  "从AI图库中选择": "Choose From AI Image Library",
  "使用中文从AI图库搜索": "Use Chinese to Search from AI Image Library",
  "AI图库": "AI Image Library",
  "确认使用": "Confirm Use",
  "AI未识别到您的商品图片": "AI Did Not Recognize Your Product Picture",
  "可在搜索框": "Available in the Search Box",
  "更换菜品名称": "Change Dish Name",
  "请输入菜品名称！": "Please Enter Dish Name!",
  "请在主语言界面上进行操作": "Please Operate on the Main Language Interface",
  "本商品正在参加活动，不能删除规格！": "This product is participating in an activity and cannot delete specifications!",
  "不能再删除了": "Can't Delete Anymore",
  "多语言": "Multilingual",
  "商品加料": "Product Additives",
  "添加加料": "Add Additives",
  "加料名称": "Additive Name",
  "如:杯型": "Like: Cup Type",
  "内容": "Content",
  "积分设置": "Points Setting",
  "是否开启积分赠送": "Whether to Open Points Gift",
  "其他设置": "Other Settings",
  "商品状态": "Product Status",
  "选择商品状态": "Choose Product Status",
  "初始销量": "Initial Sales",
  "商品排序": "Product Sorting",
  "限购数量": "Purchase Limit Quantity",
  "每个会员购买的最大数量，0为不限购": "The maximum number each member can purchase, 0 is no limit",
  "会员折扣设置": "Member Discount Setting",
  "是否开启会员折扣": "Whether to Open Member Discount",
  "默认折扣": "Default Discount",
  "单独设置折扣": "Set Discount Separately",
  "默认折扣：默认为用户所属会员等级的折扣率": "Default Discount: The default is the discount rate of the member level to which the user belongs",
  "折扣佣金类型": "Discount Commission Type",
  "百分比": "Percentage",
  "固定金额": "Fixed Amount",
  "折扣": "Discount",
  "请输入折扣": "Please Enter Discount",
  "分销设置": "Distribution Setting",
  "是否开启分销": "Whether to Open Distribution",
  "分销规则": "Distribution Rule",
  "平台规则": "Platform Rule",
  "单独规则": "Separate Rule",
  "平台规则：层级": "Platform Rule: Level",
  "1级佣金": "Level 1 Commission",
  "2级佣金": "Level 2 Commission",
  "3级佣金": "Level 3 Commission",
  "分销佣金类型": "Distribution Commission Type",
  "单独分销设置": "Separate Distribution Setting",
  "一级佣金": "Level 1 Commission",
  "二级佣金": "Level 2 Commission",
  "三级佣金": "Level 3 Commission",
  "请填写商品名称": "Please Fill in Product Name",
  "你选择商品分类": "You Choose Product Category",
  "商品卖点": "Product Selling Point",
  "配料": "Ingredients",
  "添加项": "Add Item",
  "删除项": "Delete Item",
  "审核状态": "Audit Status",
  "选择审核状态": "Choose Audit Status",
  "通过": "Pass",
  "未通过": "Not Pass",
  "审核备注": "Audit Remark",
  "请输入拒绝原因": "Please Enter the Reason for Rejection",
  "商品属性": "Product Attributes",
  "添加属性": "Add Attributes",
  "属性名称": "Attribute Name",
  "属性值": "Attribute Value",
  "至少填写两个": "At Least Fill in Two",
  "如:温度": "Like: Temperature",
  "口味": "Taste",
  "商品同步": "Product Synchronization",
  "同步至外卖": "Synchronize to Takeaway",
  "库存数量": "Inventory Quantity",
  "请填写库存数量": "Please Fill in Inventory Quantity",
  "请上传分类图片": "Please Upload Category Picture",
  "发布": "Publish",
  "级": "Level",
  "请填写口味": "Please Fill in Taste",
  "从AI图库搜索": "Search from AI Image Library",
  "AI获取标签": "AI Gets Tags",
  "标签": "Tag",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "The added tags can help the AI ordering assistant understand the customer's ordering needs more accurately",
  "同步至店内": "Synchronize to In-Store",
  "是否同步商品至外卖": "Whether to Synchronize Products to Takeaway",
  "是否同步商品至店内": "Whether to Synchronize Products to In-Store",
  "付款减库存": "Payment to Reduce Inventory",
  "菜品录入使用语言": "Language Used for Dish Entry",
  "网站主页": "Website Homepage",
  "主题编辑": "Theme Edit",
  "我的菜单": "My Menu",
  "添加菜单": "Add Menu",
  "菜单名称": "Menu Name",
  "图标": "Icon",
  "是否显示": "Whether to Show",
  "添加时间": "Add Time",
  "更新时间": "Update Time",
  "操作": "Operation",
  "正在处理": "Processing",
  "处理失败，请重试": "Processing Failed, Please Try Again",
  "此操作将永久删除该记录, 是否继续?": "This operation will permanently delete this record, do you want to continue?",
  "确定": "Confirm",
  "主题选择": "Theme Selection",
  "主题一": "Theme One",
  "主题二": "Theme Two",
  "主题三": "Theme Three",
  "主题四": "Theme Four",
  "主题五": "Theme Five",
  "主题六": "Theme Six",
  "主页预览": "Homepage Preview",
  "撤回": "Withdraw",
  "获取预览网站失败,请检查网络或联系管理员": "Failed to get preview website, please check network or contact administrator",
  "撤回成功": "Withdrawal Successful",
  "编辑菜单": "Edit Menu",
  "请输入广告标题": "Please Enter Advertisement Title",
  "图标大小为": "Icon Size is",
  "显示": "Display",
  "隐藏": "Hide",
  "请输入数字": "Please Enter Number",
  "链接": "Link",
  "选择链接": "Choose Link",
  "提交": "Submit",
  "请输入菜单名称": "Please Enter Menu Name",
  "链接到": "Link to",
  "请上传图标": "Please Upload Icon",
  "确定要删除吗?": "Are You Sure You Want to Delete?",
  "次浏览": "Times Viewed",
  "每日必拼": "Daily Must Fight",
  "更多": "More",
  "2人团": "2-Person Group",
  "去开团": "Go Start a Group",
  "活动砍价": "Activity Bargain",
  "已抢2件": "Already Grabbed 2 Pieces",
  "立即砍价": "Bargain Now",
  "满": "Full",
  "可用": "Available",
  "立即领取": "Receive Now",
  "热门直播": "Hot Live",
  "已售": "Sold",
  "限时秒杀": "Limited Time Seconds Kill",
  "搜索商品": "Search Products",
  "线下门店": "Offline Store",
  "门店地址": "Store Address",
  "联系电话": "Contact Number",
  "您的浏览器不支持 video 标签": "Your Browser Does Not Support Video Tags",
  "店家正在直播、折扣套餐秒杀中": "The Shopkeeper is Live Broadcasting, Discount Package Seconds Kill",
  "进入": "Enter",
  "至少保留一个": "Keep At Least One",
  "咨询分类": "Consultation Category",
  "全部分类": "All Categories",
  "显示数量": "Display Quantity",
  "咨询数据请到": "Consultation Data Please Go to",
  "插件": "Plugin",
  "资讯": "Information",
  "显示类型": "Display Type",
  "有图模式": "With Picture Mode",
  "无图模式": "No Picture Mode",
  "组件样式": "Component Style",
  "显示内容": "Display Content",
  "拼团价格": "Group Fight Price",
  "划线价格": "Strike-through Price",
  "指示点颜色": "Indicator Point Color",
  "重置": "Reset",
  "切换时间": "Switching Time",
  "轮播图自动切换的间隔时间，单位：毫秒": "Interval Time for Carousel Picture Auto-Switching, Unit: Millisecond",
  "链接地址": "Link Address",
  "请选择链接地址": "Please Select Link Address",
  "添加一个": "Add One",
  "标题内容": "Title Content",
  "文字内容": "Text Content",
  "链接名称": "Link Name",
  "正在砍价": "Bargaining",
  "商品原价": "Original Price of Goods",
  "背景颜色": "Background Color",
  "组件高度": "Component Height",
  "上下边距": "Top and Bottom Margin",
  "线条样式": "Line Style",
  "实线": "Solid Line",
  "虚线": "Dashed Line",
  "点状": "Dotted",
  "线条颜色": "Line Color",
  "线条高度": "Line Height",
  "左右边距": "Left and Right Margin",
  "标题": "Title",
  "颜色": "Color",
  "每行数量": "Number Per Row",
  "1个": "1 Piece",
  "2个": "2 Pieces",
  "文字颜色": "Text Color",
  "公告图标": "Announcement Icon",
  "公告内容": "Announcement Content",
  "商品来源": "Product Source",
  "自动获取": "Auto Acquire",
  "手动选择": "Manual Selection",
  "综合": "Comprehensive",
  "商品列表": "Product List",
  "选择产品": "Choose Product",
  "列表平铺": "List Paving",
  "横向滑动": "Horizontal Scroll",
  "分列数量": "Number of Columns",
  "单列": "Single Column",
  "两列": "Two Columns",
  "三列": "Three Columns",
  "商品价格": "Product Price",
  "商品销量": "Product Sales",
  "提示文字": "Prompt Text",
  "搜索框样式": "Search Box Style",
  "方形": "Square",
  "圆角": "Rounded Corner",
  "圆弧": "Arc",
  "文字对齐": "Text Alignment",
  "居左": "Left",
  "居中": "Center",
  "居右": "Right",
  "秒杀价格": "Seconds Kill Price",
  "底边距": "Bottom Margin",
  "右边距": "Right Margin",
  "不透明度": "Opacity",
  "客服类型": "Customer Service Type",
  "在线聊天": "Online Chat",
  "拨打电话": "Make a Call",
  "电话号码": "Telephone Number",
  "客服图标": "Customer Service Icon",
  "标题类型": "Title Type",
  "页面名称": "Page Name",
  "页面名称仅用于后台查找": "Page Name is Only Used for Backend Search",
  "分享标题": "Share Title",
  "小程序端转发时显示的标题": "Title Displayed When Mini Program is Forwarded",
  "文章数据请到": "Article Data Please Go to",
  "内容管理": "Content Management",
  "文章列表": "Article List",
  "中管理": "Manage in",
  "单行": "Single Line",
  "两行": "Two Lines",
  "门店列表": "Store List",
  "选择门店": "Choose Store",
  "展示数量": "Display Quantity",
  "视频高度": "Video Height",
  "滑块可用左右方向键精确调整": "The Slider Can Be Accurately Adjusted with Left and Right Arrow Keys",
  "视频封面": "Video Cover",
  "视频地址": "Video Address",
  "自动播放": "Auto Play",
  "布局方式": "Layout Method",
  "堆积两列": "Stack Two Columns",
  "堆积三列": "Stack Three Columns",
  "堆积四列": "Stack Four Columns",
  "橱窗样式": "Showcase Style",
  "橱窗样式最多显示四张图片，超出隐藏": "Showcase Style Displays up to Four Images, Hidden if Exceeded",
  "请确保所有图片的尺寸/比例相同": "Please Ensure That All Images Have the Same Size/Proportion",
  "标题文字": "Title Text",
  "组件库": "Component Library",
  "媒体组件": "Media Component",
  "商城组件": "Shopping Mall Component",
  "工具组件": "Tool Component",
  "登录组件": "Login Component",
  "资讯管理": "Information Management",
  "添加资讯": "Add Information",
  "资讯ID": "Information ID",
  "封面": "Cover",
  "资讯标题": "Information Title",
  "虚拟阅读量": "Virtual Reading Volume",
  "实际阅读量": "Actual Reading Volume",
  "资讯排序": "Information Sorting",
  "已取消删除": "Cancellation of Deletion",
  "请输入文章标题": "Please Enter Article Title",
  "描述": "Description",
  "请输入文章描述": "Please Enter Article Description",
  "缩略图": "Thumbnail",
  "资讯分类": "Information Category",
  "资讯状态": "Information Status",
  "资讯内容": "Information Content",
  "分类ID": "Category ID",
  "编辑分类": "Edit Category",
  "恭喜你，修改成功": "Congratulations, Modification Successful",
  "编辑资讯": "Edit Information",
  "份": "Portion",
  "中文": "Chinese",
  "英语": "English",
  "意大利语": "Italian",
  "德语": "German",
  "西班牙语": "Spanish",
  "法语": "French",
  "克罗地亚": "Croatian",
  "斯洛文尼亚": "Slovenian",
  "匈牙利语": "Hungarian",
  "规格库": "Specification Library",
  "属性库": "Attribute Library",
  "加料库": "Add Material Library",
  "规格名": "Specification Name",
  "批量删除": "Batch Delete",
  "请输入规格名称": "Please Enter Specification Name",
  "删除后不可恢复，确认删除吗?": "Cannot be recovered after deletion, confirm to delete?",
  "属性名": "Attribute Name",
  "请输入属性名称": "Please Enter Attribute Name",
  "请输入属性值": "Please Enter Attribute Value",
  "添加属性名": "Add Attribute Name",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Real-time Overview",
  "营业总额": "Total Business Revenue",
  "有效订单": "Valid Orders",
  "退款金额": "Refund Amount",
  "销量排行榜": "Sales Ranking",
  "销售额排行榜": "Sales Amount Ranking",
  "商品排行榜": "Product Ranking",
  "订单号": "Order Number",
  "请输入订单号": "Please Enter Order Number",
  "起始时间": "Start Time",
  "至": "To",
  "开始日期": "Start Date",
  "结束日期": "End Date",
  "查询": "Query",
  "导出": "Export",
  "全部订单": "All Orders",
  "未付款": "Unpaid",
  "进行中": "In Progress",
  "已完成": "Completed",
  "订单信息": "Order Information",
  "下单时间": "Order Time",
  "取消申请中": "Cancellation Application In Progress",
  "实付款": "Actual Payment",
  "含服务费": "Including Service Fee",
  "含包装费": "Including Packaging Fee",
  "买家": "Buyer",
  "门店名称": "Store Name",
  "出餐状态": "Meal Status",
  "准备中": "Preparing",
  "出餐中": "Cooking",
  "待取餐": "Waiting for Pickup",
  "交易状态": "Transaction Status",
  "支付方式": "Payment Method",
  "配送方式": "Delivery Method",
  "订单详情": "Order Details",
  "出餐": "Serve Meal",
  "退款": "Refund",
  "核销": "Verify",
  "确定要出餐吗?": "Are You Sure You Want to Serve the Meal?",
  "确定要核销吗?": "Are You Sure You Want to Verify?",
  "恭喜你，操作成功": "Congratulations, Operation Successful",
  "已取消核销": "Verification Cancelled",
  "基本信息": "Basic Information",
  "订单来源": "Order Source",
  "订单金额": "Order Amount",
  "配送费": "Delivery Fee",
  "服务费": "Service Fee",
  "优惠券抵扣": "Coupon Deduction",
  "积分抵扣": "Points Deduction",
  "满减金额": "Full Reduction Amount",
  "优惠金额": "Discount Amount",
  "实付款金额": "Actual Payment Amount",
  "用餐方式": "Dining Method",
  "取餐时间": "Pickup Time",
  "桌号": "Table Number",
  "修改价格": "Modify Price",
  "门店信息": "Store Information",
  "商品信息": "Product Information",
  "会员折扣价": "Member Discount Price",
  "购买数量": "Purchase Quantity",
  "商品总价": "Total Product Price",
  "收货信息": "Receiving Information",
  "收货人": "Recipient",
  "收货电话": "Recipient's Phone",
  "收货地址": "Receiving Address",
  "备注": "Remark",
  "自提用户信息": "Self-pickup User Information",
  "用户信息": "User Information",
  "联系手机": "Contact Mobile",
  "付款信息": "Payment Information",
  "应付款金额": "Amount Payable",
  "支付流水号": "Payment Serial Number",
  "付款状态": "Payment Status",
  "付款时间": "Payment Time",
  "发货信息": "Delivery Information",
  "发货状态": "Delivery Status",
  "取消信息": "Cancellation Information",
  "商家备注": "Seller's Remark",
  "门店自提核销": "Store Self-Pickup Write-off",
  "核销员": "Write-off Clerk",
  "核销状态": "Write-off Status",
  "已核销": "Written Off",
  "核销时间": "Write-off Time",
  "返回上一页": "Return to Previous Page",
  "确认发货": "Confirm Delivery",
  "确认审核": "Confirm Review",
  "请选择物流公司": "Please Select Logistics Company",
  "请填写物流单号": "Please Fill in the Logistics Number",
  "恭喜你，发货成功": "Congratulations, Delivery Successful",
  "恭喜你，审核成功": "Congratulations, Review Successful",
  "订单价格修改": "Order Price Modification",
  "运费金额": "Freight Amount",
  "最终付款价": "Final Payment Price",
  "取消订单": "Cancel Order",
  "请输入备注": "Please Enter Remark",
  "请输入退款金额": "Please Enter Refund Amount",
  "确认退款?": "Confirm Refund?",
  "已取消退款": "Refund Cancelled",
  "含配送费": "Including Delivery Fee",
  "确认送达": "Confirm Delivery",
  "是否确认此操作?": "Do You Confirm This Operation?",
  "配送状态": "Delivery Status",
  "备注信息": "Remark Information",
  "期望配送时间": "Expected Delivery Time",
  "订单状态": "Order Status",
  "骑手姓名": "Rider's Name",
  "骑手电话": "Rider's Phone",
  "操作时间": "Operation Time",
  "详情": "Details",
  "此操作将确认送达, 是否继续?": "This Operation Will Confirm Delivery, Do You Want to Continue?",
  "配送时间": "Delivery Time",
  "配送信息": "Delivery Information",
  "配送类型": "Delivery Type",
  "配送距离": "Delivery Distance",
  "配送电话": "Delivery Phone",
  "配送费用": "Delivery Fee",
  "送达时间": "Arrival Time",
  "取消原因": "Cancellation Reason",
  "请输入取消原因": "Please Enter Cancellation Reason",
  "米": "Meter",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "Store ID",
  "联系地址": "Contact Address",
  "下载二维码": "Download QR Code",
  "H5网页": "H5 Webpage",
  "添加门店": "Incorporate Establishment",
  "设置": "Configuration",
  "恭喜你，门店删除成功": "Congratulations, Successful Deletion of Store",
  "请输入地点": "Please Enter Location",
  "添加": "Incorporate",
  "等级": "Grade",
  "请选择会员等级": "Please Select Membership Grade",
  "性别": "Gender",
  "请选择性别": "Please Select Gender",
  "微信昵称": "WeChat Nickname",
  "请输入微信昵称": "Please Enter WeChat Nickname",
  "微信头像": "WeChat Profile Picture",
  "昵称": "Nickname",
  "用户余额": "User Balance",
  "累积消费金额": "Accumulated Consumption Amount",
  "注册时间": "Registration Time",
  "分钟后自动清理桌台": "Automatically Clean the Tables After Minutes",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Scheduled Table Cleaning Time for Scanning Table Codes for Ordering and Cash Register Tables",
  "到店自提": "Pickup in Store",
  "打包带走": "Takeout",
  "店内就餐": "Dine-In",
  "外卖配送至少选择一种！": "Select at Least One Delivery Method for Takeout!",
  "店内配置至少选择一种！": "Select at Least One In-Store Configuration!",
  "恭喜你，设置成功": "Congratulations, Successful Configuration",
  "恭喜你，门店修改成功": "Congratulations, Successful Store Modification",
  "门店": "Store",
  "提现金额": "Withdrawal Amount",
  "打款方式": "Payment Method",
  "待审核": "Pending Review",
  "审核通过": "Approved",
  "驳回": "Rejected",
  "原因": "Reason",
  "已打款": "Payment Made",
  "审核": "Review",
  "确认打款": "Confirm Payment",
  "确认要打款吗?": "Confirm Payment?",
  "供应商名称": "Supplier Name",
  "余额变动场景": "Balance Change Scenario",
  "收入": "Income",
  "提现": "Withdrawal",
  "起始日期": "Start Date",
  "变动金额": "Amount Changed",
  "描述/说明": "Description/Explanation",
  "创建时间": "Creation Time",
  "恭喜你，门店添加成功": "Congratulations, Successful Store Addition",
  "驳回原因": "Reason for Rejection",
  "提现审核": "Withdrawal Review",
  "小票打印设置": "Receipt Printing Setting",
  "是否开启商户小票打印": "Enable Merchant Receipt Printing",
  "选择打印机": "Select Printer",
  "是否开启顾客小票打印": "Enable Customer Receipt Printing",
  "选择打印机二": "Select Printer Two",
  "是否开启厨房小票打印": "Enable Kitchen Receipt Printing",
  "选择打印机三": "Select Printer Three",
  "恭喜你，打印设置成功": "Congratulations, Successful Printing Setting",
  "小票打印机列表": "List of Receipt Printers",
  "打印机ID": "Printer ID",
  "打印机名称": "Printer Name",
  "编辑小票打印机": "Edit Receipt Printer",
  "打印机类型": "Printer Type",
  "米泰打印机": "Mettai Printer",
  "打印机编号": "Printer Serial Number",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "The printer serial number consists of 9 digits, check the number on the sticker above the base of the Mettai printer",
  "打印机秘钥": "Printer Key",
  "打印联数": "Printing Copies",
  "同一订单，打印的次数": "Number of Prints for the Same Order",
  "排序": "Ordering",
  "数字越小越靠前": "Smaller number means higher priority",
  "新增小票打印机": "Add New Receipt Printer",
  "恭喜你，添加成功": "Congratulations, Successful Addition",
  "配送方式设置": "Delivery Method Setting",
  "商家配送": "Merchant Delivery",
  "自动配送时间(分钟)": "Automatic Delivery Time (minutes)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Setting to 0 means no automatic delivery. After ordering without delivery, automatic delivery will be initiated after the set time",
  "商户编号": "Merchant ID",
  "门店编号": "Store ID",
  "环境": "Environment",
  "测试环境": "Test Environment",
  "正式环境": "Production Environment",
  "回调地址": "Callback Address",
  "运营城市": "Operational City",
  "恭喜你，上传设置成功": "Congratulations, Successful Upload Setting",
  "菜品打印列表": "Food Printing List",
  "名称": "Name",
  "打印类型": "Printing Type",
  "外卖": "Takeout",
  "店内": "Dine-In",
  "菜品打印": "Food Printing",
  "是否开启": "Enable",
  "配送打印": "Delivery Printing",
  "店内打印": "In-House Printing",
  "打印方式": "Printing Method",
  "付款打印": "Payment Printing",
  "下单打印": "Order Printing",
  "商品分组": "Product Grouping",
  "男": "Male",
  "女": "Female",
  "未知": "Unknown",
  "文件管理": "File Management",
  "移动至": "Move to",
  "点击上传": "Click to Upload",
  "删除失败": "Deletion Failed",
  "请选择文件": "Please Select a File",
  "确定移动选中的文件吗？, 是否继续?": "Are you sure you want to move the selected files? Do you want to continue?",
  "只能上传图片！": "Only images can be uploaded!",
  "上传文件只能是图片格式!": "Uploaded file must be in image format!",
  "上传文件大小不能超过 2MB!": "Uploaded file size cannot exceed 2MB!",
  "请查看/裁切其它上传图片!": "Please view/crop other uploaded images!",
  "图片上传中,请等待": "Image uploading, please wait",
  "当前图片上传失败!": "Current image upload failed!",
  "本次上传图片失败": "Image upload failed this time",
  "本次最多只能上传1个文件": "Only 1 file can be uploaded at a time",
  "裁剪图片": "Crop Image",
  "选择优惠券": "Choose Coupon",
  "数量": "Quantity",
  "无限制": "Unlimited",
  "请输入等级名称": "Please Enter Grade Name",
  "长度在3到5个字符": "Length should be between 3 and 5 characters",
  "错了哦，这是一条错误消息": "Oops, this is an error message",
  "增加税率": "Add Tax Rate",
  "税率分类": "Tax Rate Category",
  "请输入税率分类": "Please Enter Tax Rate Category",
  "自定义税率分类": "Custom Tax Rate Category",
  "请输入税率值": "Please Enter Tax Rate Value",
  "单位是": "The unit is",
  "适用菜品分类": "Applicable Food Category",
  "请选择菜品分类": "Please Select Food Category",
  "修改税率信息": "Modify Tax Rate Information",
  "分类名称不能为空": "Category Name cannot be empty",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Membership Management",
  "等级管理": "Level Management",
  "余额明细": "Balance Details",
  "请输入昵称": "Please enter nickname",
  "邮箱": "Email",
  "请输入邮箱地址": "Please enter email address",
  "会员等级": "Membership Level",
  "全部": "All",
  "无等级": "No Level",
  "余额": "Balance",
  "积分": "Points",
  "生日": "Birthday",
  "充值": "Top-up",
  "恭喜你，用户删除成功": "Congratulations, user deleted",
  "请选择等级": "Please select level",
  "管理员备注": "Admin Remarks",
  "请输入管理员备注": "Please enter admin remarks",
  "恭喜你，用户修改成功": "Congratulations, user modified successfully",
  "会员充值": "Member Top-up",
  "充值余额": "Top-up amount",
  "当前余额": "Current balance",
  "充值方式": "Top-up method",
  "增加": "Increase",
  "减少": "Decrease",
  "最终金额": "Final amount",
  "变更金额": "Changed amount",
  "请输入变更金额": "Please enter changed amount",
  "添加等级": "Add level",
  "等级名称": "Level name",
  "权重": "Weight",
  "升级条件": "Upgrade conditions",
  "等级权重": "Level weight",
  "请输入等级权重": "Please enter level weight",
  "权重越大，等级越高": "The higher the weight, the higher the level",
  "等级折扣": "Level discount",
  "请输入等级折扣": "Please enter level discount",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Satisfy one of the checked conditions below, and the member will be automatically upgraded to that level",
  "累计消费满": "Cumulative spending reaches",
  "编辑等级": "Edit Level",
  "累计积分满": "Cumulative points reach",
  "推荐人数满": "Recommended number reaches",
  "恭喜你，等级修改成功": "Congratulations, level modified successfully",
  "个": "pieces",
  "充值设置": "Top-up Settings",
  "是否开启余额充值": "Enable balance top-up",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Note: If enabled, the top-up button will be displayed on the mobile end; if the mini-program fails the qualification review, it can remain disabled",
  "是否开启自定义金额": "Enable custom amount",
  "注：如开启则用户可以填写充值金额": "Note: If enabled, users can enter a custom top-up amount",
  "最低充值金额": "Minimum top-up amount",
  "注：自定义充值金额最低充值多少€": "Note: What is the minimum top-up amount for custom top-up amounts?",
  "充值说明": "Top-up Instructions",
  "充值套餐": "Top-up Packages",
  "支付金额": "Payment Amount",
  "到账数量": "Amount Received",
  "充值时间": "Top-up Time",
  "到账金额": "Received Amount",
  "赠送金额": "Gift Amount",
  "提现设置": "Withdrawal Settings",
  "是否开启提现": "Enable withdrawals",
  "注：如开启则移动端显示余额提现": "Note: If enabled, the mobile end will display the balance withdrawal option",
  "提现比例": "Withdrawal Percentage",
  "注：提现比例请填写数字0~100": "Note: Please enter a withdrawal percentage between 0 and 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Example: Withdrawal Amount ($100) * Withdrawal Percentage (100%) = Actual Received Amount (€100)",
  "最低提现金额": "Minimum Withdrawal Amount",
  "注：最低提现金额多少元": "Note: What is the minimum withdrawal amount in yuan?",
  "请选择状态": "Please select status",
  "提现方式": "Withdrawal Method",
  "请选择提现方式": "Please select a withdrawal method",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bank Card",
  "请输入用户ID": "Please enter user ID",
  "请输入昵称/姓名/手机号": "Please enter nickname/name/mobile number",
  "提现信息": "Withdrawal Information",
  "支付宝名称": "Alipay Name",
  "支付宝账号": "Alipay Account",
  "银行名称": "Bank Name",
  "开户名": "Account Name",
  "银行卡号": "Bank Card Number",
  "申请时间": "Application Time",
  "审核时间": "Review Time",
  "微信付款": "WeChat Payment",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "This operation will use WeChat's corporate payment function to transfer to the wallet. Are you sure you want to proceed?",
  "添加充值套餐": "Add Top-up Package",
  "套餐名称": "Package Name",
  "请输入套餐名称": "Please enter package name",
  "请输入支付金额": "Please input the amount for payment",
  "请输入赠送金额": "Kindly provide the amount for gifting",
  "请输入到账金额": "Please specify the credited amount",
  "请输入排序": "Please input the sorting order",
  "用户ID": "User Identification",
  "会员卡管理": "Management of Membership Cards",
  "领取记录": "Records of Receptions",
  "删除记录": "Delete Record",
  "请输入关键词": "Please enter the keyword",
  "过期": "Expired",
  "有效": "Valid",
  "客户信息": "Client Data",
  "会员卡名称": "Name of Membership Card",
  "有效期": "Validity Period",
  "折": "Discount",
  "领取时间": "Reception Time",
  "延期": "Extension",
  "撤销": "Revoke",
  "添加会员卡": "Add Membership Card",
  "启用": "Activate",
  "关闭": "Deactivate",
  "月": "Month",
  "永久有效": "Perpetually Valid",
  "领取数量": "Number of Receivers",
  "发卡": "Issue Card",
  "领取设置": "Settings for Receiving",
  "请检查必填项是否填写完整": "Please review if the mandatory fields are fully filled",
  "领取人数": "Number of Recipients",
  "删除时间": "Deletion Time",
  "请填写有效期": "Please fill in the validity period",
  "有效期限（月），0为永久有效": "Validity period (in months), 0 for indefinite validity",
  "请填写价格": "Kindly provide the price",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "The amount users need to pay to purchase the membership card, 0 for free issuance",
  "使用须知": "Usage Guidelines",
  "请填写使用须知": "Please provide usage instructions",
  "请填写会员卡名称": "Please fill in the membership card name",
  "卡片类型": "Card Type",
  "卡片样式": "Card Style",
  "请填写排序": "Please enter the sorting order",
  "会员权益": "Membership Benefits",
  "无折扣": "No Discount",
  "请填写折扣": "Please fill in the discount",
  "开卡赠送": "Gift on Card Activation",
  "优惠券": "Coupon",
  "请填写积分数量": "Please provide the quantity of points",
  "请填写余额数量": "Please provide the balance amount",
  "请填写优惠券": "Please fill in the coupon",
  "添加优惠券": "Add Coupon",
  "券名称": "Coupon Name",
  "每人领取数量": "Quantity per person",
  "选择优惠券弹出层": "Selection of Coupon Popup",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "You have already selected fifteen coupons, please delete others if you wish to replace them!",
  "产品编码": "Product Code",
  "请填写产品编码": "Please fill in the product code",
  "产品划线价": "Product List Price",
  "请填写产品划线价": "Please provide the product list price",
  "商品重量": "Product Weight",
  "请填写商品重量": "Please provide the product weight",
  "批量设置": "Bulk Settings",
  "划线价": "List Price",
  "重量": "Weight",
  "应用": "Apply",
  "规格图片": "Specification Image",
  "规格值": "Specification Value",
  "请输入规格值": "Please input the specification value",
  "请填写规则名或规则值": "Please input the rule name or rule value",
  "规格值不能为空": "Specification value cannot be empty",
  "卡名称": "Card Name",
  "卡ID": "Card Identification",
  "无": "None",
  "选择会员": "Select Member",
  "恭喜你，发卡成功": "Congratulations, card issuance successful",
  "副卡数": "Number of Supplementary Cards",
  "张": "pieces",
  "选择日期": "Select Date",
  "签到设置": "Check-in Settings",
  "签到记录": "Check-in Records",
  "是否开启签到有礼": "Enable Check-in Rewards",
  "每日签到固定奖励": "Fixed Reward for Daily Check-ins",
  "每日签到送": "Daily Check-in Reward",
  "递增奖励": "Incremental Reward",
  "有": "Yes",
  "第二天起递增奖励": "Incremental Reward Starting from Day Two",
  "第": "Day",
  "天起不再递增": "No more increment from this day onwards",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Extra Rewards for Continuous Check-ins (Upon reaching the maximum extra reward days, further check-ins will not receive extra rewards; the count restarts after missing a check-in)",
  "额外奖励": "Additional Reward",
  "连续签到": "Consecutive Check-ins",
  "请输入连续签到天数": "Please input the number of consecutive check-in days",
  "积分奖励": "Point Rewards",
  "送": "gifting",
  "请输入连续签到天数的积分": "Please provide points for consecutive check-in days",
  "规则": "Rules",
  "规则说明": "Explanation of Rules",
  "请添加至少一项额外奖励！": "Please add at least one additional reward!",
  "天数不能为空！": "Days cannot be empty!",
  "请输入连续签到积分数！": "Please input the points for consecutive check-ins!",
  "每日签到送积分有误": "Error in daily check-in points reward",
  "请输入第二天起递增积分数": "Please input the incremental points starting from the second day",
  "请输入第几天不再递增": "Please enter the day when increment stops",
  "恭喜你，保存成功": "Congratulations, save successful",
  "连续签到天数": "Consecutive Check-in Days",
  "不限": "Unlimited",
  "签到时间": "Check-in Time",
  "时间": "Time",
  "请输入用户昵称": "Please enter user nickname",
  "签到日期": "Check-in Date",
  "活动奖品": "Activity Prizes",
  "取号记录": "Number Reservation Records",
  "桌号管理": "Table Management",
  "取号设置": "Number Reservation Settings",
  "请输入手机号": "Please input the phone number",
  "待叫号": "To be called",
  "就餐号": "Dining Number",
  "就餐人数": "Number of Diners",
  "桌位名称": "Table Name",
  "取号时间": "Number Reservation Time",
  "待取号": "To be reserved",
  "已入座": "Seated",
  "已过号": "Missed",
  "是否开启打印": "Enable Printing",
  "须知": "Instructions",
  "请输入须知": "Please input the instructions",
  "商家说明": "Merchant Description",
  "请输入商家说明": "Please provide the merchant description",
  "取号规则": "Number Reservation Rules",
  "等待时间": "Wait Time",
  "人数最小值": "Minimum Number of People",
  "人数最大值": "Maximum Number of People",
  "等待时间(分钟)": "Wait Time (minutes)",
  "请输入桌位名称": "Please enter the table name",
  "请输入人数最小值": "Please input the minimum number of people",
  "请输入人数最大值": "Please input the maximum number of people",
  "请输入等待时间": "Please input the wait time",
  "商品设置": "Product Settings",
  "兑换记录": "Redemption Records",
  "活动名称": "Activity Name",
  "请输入活动名称": "Please input the activity name",
  "活动列表": "List of Activities",
  "添加活动": "Add Activity",
  "活动价格": "Activity Price",
  "发放数量": "Distribution Quantity",
  "参与人数": "Number of Participants",
  "终止": "Terminate",
  "购买记录": "Purchase Records",
  "新增活动会场": "Add New Activity Venue",
  "活动标题": "Activity Title",
  "请输入活动标题": "Kindly input the activity title",
  "活动日期": "Activity Date",
  "礼包设置": "Gift Package Configuration",
  "优惠券id": "Coupon ID",
  "购买设置": "Purchase Settings",
  "购买金额": "Purchase Amount",
  "会员购买等级": "Member Purchase Level",
  "指定等级": "Designated Level",
  "购买次数": "Purchase Frequency",
  "限购": "Purchase Limit",
  "每人限购": "Per Person Purchase Limit",
  "次": "Times",
  "发放设置": "Distribution Settings",
  "请输入发放数量": "Please enter the distribution quantity",
  "返回": "Return",
  "请勿重复添加": "Please avoid duplicate additions",
  "至少选择一个优惠券": "Please select at least one coupon",
  "新增活动": "Add New Activity",
  "券包设置": "Coupon Package Settings",
  "下载推广码": "Download Promo Code",
  "下载类型": "Download Type",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Before using this feature, navigate to the backend of the mini-program, and in 'Settings'-'Interface Settings'-'Public Account Follow Component,' set the public account to be displayed. Note: The set public account must match the mini-program entity",
  "去配置": "Go to Configuration",
  "若没有配置公众号，功能将不生效": "If no public account is configured, the function will not take effect",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Only when entering the mini-program from the following scenes during its lifecycle can the ability to display and guide to follow the public account be activated",
  "当小程序从扫小程序码打开时": "When the mini-program is opened by scanning the mini-program code",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "When returning to the mini-program from another mini-program, if the previous mini-program was not destroyed, the component will retain the state from the last time the mini-program was opened",
  "公众号关注": "Public Account Subscription",
  "新客设置": "New Customer Configuration",
  "是否开启活动": "Is the activity enabled?",
  "活动时间": "Activity Period",
  "背景图": "Background Image",
  "赠送优惠券": "Coupon Gifting",
  "请选择优惠券": "Please select a coupon",
  "赠送积分": "Point Gifting",
  "请输入赠送积分": "Please enter the points to be gifted",
  "直播同步": "Live Broadcast Synchronization",
  "同步直播": "Synchronize Live Broadcast",
  "请输入直播间名称/主播昵称": "Please enter the live room name/host nickname",
  "直播间ID": "Live Room ID",
  "直播间名称": "Live Room Name",
  "主播昵称": "Host Nickname",
  "直播开始时间": "Live Start Time",
  "直播结束时间": "Live End Time",
  "直播间状态": "Live Room Status",
  "置顶": "Pin to Top",
  "未置顶": "Not Pinned",
  "已置顶": "Pinned",
  "设为置顶": "Set as Top",
  "取消置顶": "Unpin",
  "直播中": "Live",
  "未开始": "Not Started",
  "已结束": "Ended",
  "禁播": "Ban Live",
  "暂停": "Pause",
  "异常": "Abnormal",
  "已过期": "Expired",
  "置顶成功": "Successfully Pinned",
  "邀请活动": "Invitation Event",
  "个人中心图片": "Personal Center Image",
  "请输入用户昵称/手机号": "Please enter user nickname/phone number",
  "邀请人": "Inviter",
  "被邀请人": "Invitee",
  "参加时间": "Participation Time",
  "个人中心显示": "Personal Center Display",
  "参与记录": "Participation Records",
  "礼品记录": "Gift Records",
  "推广二维码": "Promotional QR Code",
  "编辑活动会场": "Edit Event Venue",
  "请输入分享标题": "Please enter sharing title",
  "请输入分享内容": "Please enter sharing content",
  "分享内容": "Share Content",
  "分享图": "Share Image",
  "个人中心状态": "Personal Center Status",
  "邀请成功的条件": "Conditions for Successful Invitation",
  "邀请成为会员": "Invite to Become a Member",
  "邀请成为会员且消费": "Invite to Become a Member and Consume",
  "礼品设置": "Gift Settings",
  "奖项": "Prize",
  "每邀请": "Per Invitation",
  "人获得礼品": "Person Receives a Gift",
  "添加奖励项": "Add Reward Item",
  "请上传背景图": "Please upload background image",
  "请上传分享图": "Please upload sharing image",
  "请添加奖项": "Please add a prize",
  "开启首页推送": "Enable Homepage Push",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "It is recommended to change the activity; changing this name will adjust the pop-up on the mall homepage according to this name",
  "类型": "Type",
  "图文": "Image Text",
  "纯图": "Pure Image",
  "领取优惠券": "Receive Coupon",
  "请输入标题": "Please enter a title",
  "弹窗图片": "Popup Image",
  "图片为2M以内大小，格式限png，jpg格式": "Image size should be within 2MB and in PNG or JPG format",
  "建议尺寸": "Suggested Size",
  "按钮文案": "Button Text",
  "简介说明": "Concise Explanation",
  "请输入说明": "Kindly Input Explanation",
  "点击选择你要链接的位置": "Click to Indicate Desired Linking Position",
  "跳转地址": "Redirection Address",
  "最多可以添加三张": "Up to Three Additions Permitted",
  "最多添加3张优惠券": "Maximum Addition Limit: 3 Coupons",
  "标题不能为空": "Title Cannot Be Empty",
  "请选择跳转链接": "Select Redirection Link",
  "请选择优惠卷": "Select Coupon",
  "请上传图片": "Please Upload Image",
  "团购订单": "Group Purchase Orders",
  "团购管理": "Group Purchase Management",
  "团购设置": "Group Purchase Settings",
  "订单设置": "Order Settings",
  "未支付订单": "Unpaid Orders",
  "请输入关闭时间": "Please Enter Closure Time",
  "团购保障": "Group Purchase Assurance",
  "使用门店": "Store Usage",
  "待付款": "Pending Payment",
  "待使用": "Awaiting Use",
  "已取消": "Cancelled",
  "已退款": "Refunded",
  "使用门店名称": "Store Name for Use",
  "门店联系人": "Store Contact",
  "门店电话": "Store Phone Number",
  "团购信息": "Group Purchase Information",
  "券码信息": "Coupon Code Information",
  "核销券码": "Redeem Coupon Code",
  "添加团购": "Add Group Purchase",
  "团购名称": "Group Purchase Name",
  "销售价格": "Selling Price",
  "虚拟销量": "Virtual Sales Volume",
  "部分": "Partial",
  "基础设置": "Basic Configuration",
  "购买须知": "Purchase Guidelines",
  "团购详情": "Group Purchase Details",
  "团购须知": "Group Purchase Guidelines",
  "请输入团购名称": "Please Enter Group Purchase Name",
  "到期类型": "Expiration Type",
  "购买后生效": "Effective Post Purchase",
  "固定时间": "Fixed Time",
  "有效天数": "Validity Period in Days",
  "请输入有效天数": "Please Input Validity Period in Days",
  "有效时间": "Valid Time",
  "请输入有效时间": "Please Enter Valid Time",
  "团购图片": "Group Purchase Image",
  "请上传团购图片": "Kindly Upload Group Purchase Image",
  "请输入划线价格": "Please Input Strikethrough Price",
  "请输入销售价格": "Please Enter Selling Price",
  "请输入虚拟销量": "Please Provide Virtual Sales Volume",
  "适用门店": "Applicable Stores",
  "请选择门店": "Select Store",
  "团购状态": "Group Purchase Status",
  "每日限购数量": "Daily Purchase Limit",
  "每个会员每日购买的最大数量，0为不限购": "Maximum Quantity Each Member Can Purchase Daily; 0 for No Limit",
  "商家名称": "Merchant Name",
  "平台": "Platform",
  "满类型": "Criteria Type",
  "满额": "Threshold Amount",
  "满件数": "Threshold Quantity",
  "满值": "Threshold Value",
  "减类型": "Deduction Type",
  "减金额": "Deduction Amount",
  "打折": "Discount",
  "减值": "Deduction Value",
  "编辑活动": "Edit Activity",
  "满金额": "Full Amount",
  "请输入满值": "Please Input Threshold Value",
  "如果是打折，填写80，表示打8折": "If Discount, Enter 80 for 20% Off",
  "满额免配送费设置": "Free Shipping on Threshold Amount",
  "是否开启满额免配送费": "Enable Free Shipping on Threshold Amount",
  "单笔订单满": "Single Order over",
  "如果开启满额免配送费，设置0为全场免配送费": "If Free Shipping Enabled, Set 0 for Entire Order",
  "入驻申请": "Settlement Application",
  "配送员": "Delivery Personnel",
  "配送订单": "Delivery Orders",
  "提现申请": "Withdrawal Request",
  "配送设置": "Delivery Settings",
  "退出申请": "Exit Request",
  "正常": "Normal",
  "押金": "Deposit",
  "累计佣金": "Accumulated Commission",
  "可提现佣金": "Commission Available for Withdrawal",
  "已提现佣金": "Commission Already Withdrawn",
  "提现明细": "Withdrawal Details",
  "申请条件": "Application Requirements",
  "结算": "Settlement",
  "是否开启押金支付": "Enable Deposit Payment",
  "是否审核": "Require Review",
  "需后台审核": "Requires Back-end Review",
  "无需审核": "No Review Needed",
  "产品列表弹出层": "Product List Pop-up",
  "已选择该商品": "Product Already Selected",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Note: For WeChat Pay, apply for in-app transfers to wallet functionality",
  "微信提现方式": "WeChat Withdrawal Method",
  "微信提现到零钱": "Withdraw to WeChat Wallet",
  "商家转账到零钱": "Merchant Transfers to Wallet",
  "注：根据实际产品开通情况选择": "Select according to actual product activation",
  "最低提现额度": "Minimum Withdrawal Limit",
  "佣金结算时间": "Commission Settlement Time",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Note: Delivery commissions settle into account n hours after completion; Set to 0 for immediate settlement",
  "请至少选择一种提现方式": "Please ensure selection of at least one withdrawal method",
  "佣金结算": "Commission Settlement",
  "是否结算佣金": "Is commission to be settled?",
  "已结算": "Settled",
  "未结算": "Not Settled",
  "送达状态": "Delivery Status",
  "查看详情": "View Details",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "This operation will utilize WeChat Enterprise Payment to transfer to your balance. Are you certain about the transaction?",
  "身份证号": "ID Number",
  "待交押金": "Pending Deposit",
  "审核方式": "Review Method",
  "查看": "Inspect",
  "配送员审核": "Delivery Personnel Review",
  "添加外卖商品": "Add Takeout Goods",
  "序号": "Number",
  "活动折扣": "Promotional Discount",
  "活动库存": "Promotional Stock",
  "添加店内商品": "Add In-store Products",
  "优惠券列表": "Coupon List",
  "发送优惠券": "Send Coupons",
  "发送对象": "Recipient",
  "全站会员": "All Site Members",
  "指定会员": "Designated Member",
  "选择会员等级": "Select Member Level",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "The recipient has reached the limit for receiving the specified coupon and will no longer receive it",
  "发送成功": "Sent Successfully",
  "优惠券ID": "Coupon ID",
  "优惠券名称": "Coupon Name",
  "优惠券类型": "Coupon Type",
  "最低消费金额": "Minimum Spending Amount",
  "优惠方式": "Discount Method",
  "立减": "Direct Reduction",
  "打": "Discount",
  "领取": "Receive",
  "天内有效": "Valid for days",
  "发放总数量": "Total Distribution Quantity",
  "不限制": "Unlimited",
  "已领取数量": "Quantity Received",
  "修改优惠券": "Modify Coupon",
  "请输入优惠券名称": "Please enter the name of the coupon",
  "例如：满100减10": "For example: Spend 100 and get 10 off",
  "优惠券颜色": "Coupon Color",
  "蓝色": "Blue",
  "红色": "Red",
  "紫色": "Purple",
  "黄色": "Yellow",
  "满减券": "Discount Voucher",
  "折扣券": "Discount Rate Coupon",
  "减免金额": "Reduction Amount",
  "请输入减免金额": "Please enter the reduction amount",
  "折扣率": "Discount Rate",
  "请输入折扣率": "Please enter the discount rate",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "The discount rate ranges from 0 to 10. For example, 9.5 represents a 5% discount, and 0 represents no discount",
  "请输入最低消费金额": "Please enter the minimum spending amount",
  "后生效": "Effective after",
  "请输入发放总数量": "Please enter the total distribution quantity",
  "限制领取的优惠券数量，-1为不限制": "Limit the number of coupons that can be received, -1 for no limit",
  "是否显示在领券中心": "Is it displayed in the coupon center?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "The pop-up prompt shown in the figure will only display once for new users when they first enter the mini-program",
  "引导收藏": "Guided Collection",
  "编辑类型": "Edit Type",
  "生日设置": "Birthday Setting",
  "手机短信": "Phone SMS",
  "分销商用户": "Distributor User",
  "分销订单": "Distribution Orders",
  "分销海报": "Distribution Posters",
  "推荐人": "Referrer",
  "下级用户": "Subordinate Users",
  "一级": "Level One",
  "二级": "Level Two",
  "三级": "Level Three",
  "成为时间": "Membership Date",
  "下级": "Subordinate",
  "加入时间": "Joining Date",
  "分销商条件": "Distributor Criteria",
  "佣金设置": "Commission Setting",
  "自定义文字": "Custom Text",
  "申请协议": "Application Agreement",
  "页面背景图": "Page Background Image",
  "分销中心页面": "Distribution Center Page",
  "页面标题": "Page Title",
  "分销中心": "Distribution Center",
  "非分销商提示": "Non-Distributor Prompt",
  "您还不是分销商，请先提交申请": "You are not a distributor yet, please submit an application first",
  "申请成为分销商": "Apply to be a Distributor",
  "立即加入": "Join Now",
  "可提现": "Available for Withdrawal",
  "待提现佣金": "Commission Pending Withdrawal",
  "待提现": "Pending Withdrawal",
  "已提现金额": "Total Withdrawn Amount",
  "去提现": "Withdraw Now",
  "申请成为分销商页面": "Apply to be a Distributor Page",
  "请填写申请信息": "Please fill in the application information",
  "分销商申请协议": "Distributor Application Agreement",
  "申请成为经销商": "Apply to be a Dealer",
  "审核中提示信息": "Under Review Notification",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Your application has been received and is undergoing information verification. Please wait patiently",
  "去商城逛逛": "Go Shopping in the Mall",
  "分销订单页面": "Distribution Order Page",
  "我的团队页面": "My Team Page",
  "我的团队": "My Team",
  "团队总人数": "Total Team Members",
  "一级团队": "Primary Team",
  "二级团队": "Secondary Team",
  "三级团队": "Tertiary Team",
  "提现明细页面": "Withdrawal Details Page",
  "审核中": "Under Review",
  "申请提现页面": "Withdrawal Request Page",
  "申请提现": "Submit Withdrawal Request",
  "请输入要提取的金额": "Please enter the desired withdrawal amount",
  "最低提现佣金": "Minimum Withdrawal Commission",
  "提交申请": "Submit Application",
  "佣金结算天数": "Commission Settlement Days",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Note: The commission from a completed order will be settled to the distributor's balance after n days. If set to 0 days, it will be settled upon order completion",
  "成为分销商条件": "Distributor Eligibility",
  "购买指定商品成为分销商": "Become a distributor by purchasing designated products",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Automatically become a distributor after purchasing designated products, no backend review required",
  "选择商品": "Select Products",
  "成为下线条件": "Become Subordinate Criteria",
  "首次点击分享链接": "First click on the shared link",
  "一级佣金比例": "Primary Commission Rate",
  "佣金比例范围 0% - 100%": "Commission rate range 0% - 100%",
  "二级佣金比例": "Secondary Commission Rate",
  "三级佣金比例": "Tertiary Commission Rate",
  "是否开启分销功能": "Enable Distribution Function",
  "分销层级": "Distribution Levels",
  "一级分销": "Primary Distribution",
  "二级分销": "Secondary Distribution",
  "三级分销": "Tertiary Distribution",
  "分销商内购": "Distributor Self-purchase",
  "如开启，分销商自己购买商品，获得一级佣金": "If enabled, distributors receive primary commission for purchases made by themselves",
  "分销中心首页": "Distribution Center Homepage",
  "尺寸：宽750像素 高度227像素": "Dimensions: Width 750 pixels, Height 227 pixels",
  "申请成为分销商页": "Apply to be a Distributor Page",
  "申请提现页": "Withdrawal Request Page",
  "分销海报设置": "Distribution Poster Settings",
  "海报背景图": "Poster Background Image",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimensions: Width 750 pixels, Height greater than or equal to 1200 pixels",
  "头像宽度": "Avatar Width",
  "头像样式": "Avatar Style",
  "正方形": "Square",
  "圆形": "Circular",
  "昵称字体大小": "Nickname Font Size",
  "昵称字体颜色": "Nickname Font Color",
  "小程序码宽度": "Mini Program Code Width",
  "小程序码样式": "Mini Program Code Style",
  "分销商": "Distributor",
  "一级分销商": "Primary Distributor",
  "用户": "User",
  "分销佣金": "Distributor Commission",
  "二级分销商": "Secondary Distributor",
  "三级分销商": "Tertiary Distributor",
  "分销商审核": "Distributor Review",
  "积分明细": "Points Details",
  "变动数量": "Quantity Changes",
  "积分名称": "Points Name",
  "例": "Example",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "After modifying the points name, the customized name will be displayed on all pages in the buyer's end",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Businesses use customized points names for branding. For example, JD calls points 'JD Beans' and Taobao calls them 'Treasure Coins'",
  "积分说明": "Points Description",
  "积分赠送": "Points Giving",
  "是否开启购物送积分": "Enable Points for Shopping",
  "积分赠送规则": "Points Giving Rules",
  "如开启则订单完成后赠送用户积分": "If enabled, points are awarded to users upon order completion",
  "订单确认收货已完成": "Order confirmation and receipt completed",
  "已完成订单超出后台设置的申请售后期限": "Completed orders exceed the post-sales period set in the backend",
  "积分赠送比例": "Points Giving Ratio",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Please enter a ratio between 0 to 100; shipping fees are not included in points giving",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Sales Statistics",
  "会员统计": "Member Statistics",
  "订单概况": "Order Overview",
  "商品概况": "Product Overview",
  "今日": "Today",
  "累积会员数": "Total Members",
  "新增会员数": "New Members",
  "成交会员数": "Transaction Members",
  "排行榜": "Leaderboard",
  "用户消费榜": "User Spending Ranking",
  "积分排行榜": "Points Ranking",
  "邀请人排行榜": "Inviter Ranking",
  "成交会员占比": "Transaction Members Ratio",
  "今天": "Today",
  "最近7天": "Past 7 Days",
  "最近30天": "Past 30 Days",
  "最近90天": "Past 90 Days",
  "最近180天": "Past 180 Days",
  "最近1年": "Past 1 Year",
  "最近2年": "Past 2 Years",
  "所有占比": "Overall Ratio",
  "成交会员": "Transaction Members",
  "未成交会员": "Non-Transaction Members",
  "新增会员": "New Members",
  "最近一周": "Last Week",
  "最近一个月": "Last Month",
  "最近三个月": "Recent three months",
  "选择店铺": "Select store",
  "查询日期": "Query date",
  "近七天": "Last seven days",
  "近十五天": "Last fifteen days",
  "自定义时间": "Customized time",
  "日期": "Date",
  "有效订单数": "Valid order count",
  "选择时间": "Select time",
  "交易统计": "Transaction statistics",
  "订单数": "Number of orders",
  "客单价": "Average order value",
  "付款订单": "Paid orders",
  "付款人数": "Number of paying customers",
  "商品统计": "Product statistics",
  "在售商品": "Available products",
  "件": "Item",
  "已付款商品": "Paid Products",
  "销量TOP10": "Top 10 Sales",
  "浏览TOP10": "Top 10 Views",
  "浏览": "View",
  "排行类型": "Ranking Type",
  "商品总数": "Total Number of Products",
  "已上架商品": "On-Shelf Products",
  "已下架商品": "Off-Shelf Products",
  "商品导出": "Product Export",
  "商品总销量": "Total Product Sales",
  "商品总销售额": "Total Sales Amount of Products",
  "资产总览": "Asset Overview",
  "财务对账": "Financial Reconciliation",
  "交易记录": "Transaction Records",
  "店铺结算": "Shop Settlement",
  "待结算金额": "Pending Settlement Amount",
  "已结算金额": "Settled Amount",
  "交易概况": "Transaction Overview",
  "外卖统计": "Takeout Statistics",
  "店内统计": "In-store Statistics",
  "订单类型": "Order Type",
  "应收金额": "Amount Receivable",
  "实付金额": "Amount Paid",
  "账户概况": "Account Overview",
  "订单编号": "Order Number",
  "支付状态": "Payment Status",
  "付款方式": "Payment Method",
  "订单费用": "Order Cost",
  "优惠": "Discount",
  "商户实际收入": "Merchant Actual Revenue",
  "商品ID": "Product ID",
  "小计": "Subtotal",
  "请输入提现金额": "Please Enter Withdrawal Amount",
  "请输入打款方式": "Please Enter Payment Method",
  "支付宝真实姓名": "Alipay Real Name",
  "请输入支付宝真实姓名": "Please Enter Alipay Real Name",
  "开户行名称": "Bank Name",
  "银行开户名": "Bank Account Name",
  "真实姓名": "Real Name",
  "应付金额": "Amount Payable",
  "实付总额": "Total Amount Paid",
  "商户": "Merchant",
  "结算金额": "Settlement Amount",
  "店铺结算金额": "Shop Settlement Amount",
  "操作提示": "Operation Tips",
  "订单结算金额 = 店铺结算总金额(含运费)": "Order Settlement Amount = Shop Settlement Total Amount (including Shipping Fee)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Shop Revenue = Shop Settlement Total Amount - Shop Refund Amount",
  "订单日期": "Order Date",
  "订单结算金额": "Order Settlement Amount",
  "配送费金额": "Delivery Fee Amount",
  "商品编码": "Product Code",
  "可用余额": "Available Balance",
  "提现概况": "Withdrawal Overview",
  "搜索": "Search",
  "支出": "Expenditure",
  "金额": "Amount",
  "收支类型": "Income and Expenditure Type",
  "确认要退吗?": "Confirm to Return?",
  "申请成功": "Application Successful",
  "门店总金额": "Total Store Amount",
  "累计收入": "Accumulated Income",
  "访客数": "Number of Visitors",
  "访问量": "Visitation Volume",
  "店铺收藏数": "Shop Favorites Count",
  "商品收藏数": "Product Favorites Count",
  "访问数": "Number of Visits",
  "收藏数": "Number of Favorites",
  "数": "Number",
  "待支付": "Pending Payment",
  "实际到账": "Actual Received Amount",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "商城设置": "Store Configuration",
  "物流公司": "Logistics Company",
  "chatgpt设置": "ChatGPT Settings",
  "消息设置": "Message Settings",
  "短信设置": "SMS Settings",
  "上传设置": "Upload Settings",
  "清理缓存": "Clear Cache",
  "网址后缀英文名称": "English Name for Website Suffix",
  "英文名称": "English Name",
  "默认头像": "Default Avatar",
  "英文名称必须只包含数字和英文字母": "The English Name must only contain numbers and letters",
  "恭喜你，商城设置成功": "Congratulations, the Store Settings are successfully applied",
  "表单数据不符合规则": "The form data does not comply with the rules",
  "剩余额度": "Remaining Limit",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "When the balance is insufficient, features such as Intelligent Customer Service, AI Magic Creation, and Multilingual Translation will be disabled",
  "使用明细": "Usage Details",
  "消费": "Expenditure",
  "额度": "Quota",
  "数据缓存": "Data Cache",
  "恭喜你，清理成功": "Congratulations, the cleaning process is successful",
  "管理员列表": "Administrator List",
  "角色管理": "Role Management",
  "登录日志": "Login Log",
  "操作日志": "Operation Log",
  "添加管理员": "Add Administrator",
  "管理员ID": "Administrator ID",
  "用户名": "Username",
  "所属角色": "Assigned Role",
  "超级管理员": "Super Administrator",
  "所属门店": "Affiliated Store",
  "门店状态": "Store Status",
  "已删除": "Deleted",
  "未删除": "Undeleted",
  "账号状态": "Account Status",
  "恭喜你，该管理员删除成功": "Congratulations, the administrator has been successfully deleted",
  "请输入用户名": "Please enter the username",
  "修改管理员": "Edit Administrator",
  "添加角色": "Add Role",
  "角色ID": "Role ID",
  "角色名称": "Role Name",
  "恭喜你，该角色删除成功": "Congratulations, the role has been successfully deleted",
  "编辑角色": "Edit Role",
  "请输入角色名称": "Please enter the role name",
  "权限列表": "Permission List",
  "请输入用户名和真实姓名": "Please enter the username and real name",
  "登录状态": "Login Status",
  "全部标记为已读": "Mark All as Read",
  "公告详情": "Announcement Details",
  "全部标记为已读消息吗?": "Mark all messages as read?",
  "操作成功!": "Operation successful!",
  "已取消操作": "Operation canceled",
  "订单流程设置": "Order Process Settings",
  "已支付订单": "Paid Orders",
  "分钟后自动关闭": "automatically close after minutes",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Orders placed but not paid, automatically close after n minutes, set to 0 for no automatic closing",
  "分钟后自动核销": "automatically validate after minutes",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "If not validated within the period, the system will automatically validate, set to 0 for no automatic validation",
  "积分商城订单流程设置": "Points Mall Order Process Settings",
  "已发货订单": "Shipped Orders",
  "天后自动核销": "automatic validation after days",
  "不包括桌台订单": "excluding table orders",
  "恭喜你，交易设置成功": "Congratulations, the transaction settings are successfully applied",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Current Version",
  "试用版": "Trial Version",
  "专业版": "Professional Edition",
  "高级版": "Advanced Edition",
  "至尊版": "Supreme Edition",
  "到期日期": "Expiration Date",
  "永不过期": "Never Expires",
  "欢迎您": "Welcome",
  "修改密码": "Change Password",
  "此操作将退出登录, 是否继续?": "This operation will log you out, do you want to continue?",
  "原始密码": "Original Password",
  "新密码": "New Password",
  "确认新密码": "Confirm New Password",
  "系统公告": "System Announcement",
  "请至少选择一件产品商品！": "Please select at least one product!",
  "超链接设置": "Hyperlink Settings",
  "图像预览": "Image Preview",
  "页面": "Page",
  "当前链接": "Current Link",
  "暂无": "None",
  "页面路径": "Page Path",
  "注意一": "Note One",
  "注意二": "Note Two",
  "注意三": "Note Three",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "For the same mini-program linking to other mini-programs, a maximum of 10 links are allowed; exceeding this limit will render them ineffective",
  "不能填写自身小程序appid": "Cannot fill in the appid of the current mini program",
  "小程序链接留空默认跳到小程序首页": "Leaving the mini-program link blank will default to the mini-program homepage",
  "分类": "Category",
  "选择": "Select",
  "签到": "Sign In",
  "积分商城": "Points Mall",
  "秒杀": "Spike Sale",
  "拼团": "Group Buying",
  "砍价": "Bargain",
  "领券中心": "Coupon Center",
  "生日有礼": "Birthday Gift",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "The linked webpage must support SSL and start with https://, otherwise it cannot be redirected",
  "链接的域名必须是备案域名，否则无法跳转": "The linked domain name must be a registered domain, otherwise it cannot be redirected",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Your website domain must be added to the business domain of the WeChat Mini Program Public Platform, can you provide more details?",
  "选择文章列表": "Select Article List",
  "文章标题": "Article Title",
  "文章分类": "Article Category",
  "选择规格": "Select Specifications",
  "产品/规格": "Product/Specifications",
  "已选": "Selected",
  "查看物流": "View Logistics",
  "请输入收货人": "Please enter the recipient",
  "请输入收获电话": "Please enter the recipient's phone number",
  "省": "Province",
  "市": "City",
  "区": "District",
  "现金收款": "Cash Payment",
  "余额收款": "Balance Payment",
  "其他方式": "Other Methods",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Please enter the member ID to search for the member, then click confirm when done",
  "请输入会员ID": "Please enter the member ID",
  "会员昵称": "Member Nickname",
  "余额总计": "Total Balance",
  "登录会员仅作为积分累计，无法享受其他优惠": "Logged-in members can only accumulate points and cannot enjoy other discounts",
  "取消收款": "Cancel Payment",
  "收款": "Receive Payment",
  "请输入会员手机号": "Please enter the member's phone number",
  "该用户不存在": "This user does not exist",
  "注册": "Register",
  "平台名称": "Platform Name",
  "请输入平台名称": "Please enter the platform name",
  "所在地区": "Location",
  "请选择所在地区": "Please select the location",
  "平台账户名": "Platform Account Name",
  "请输入平台账户名": "Please enter the platform account name",
  "平台账户密码": "Platform Account Password",
  "是否连锁": "Is it a chain?",
  "是": "Yes",
  "否": "No",
  "请输入您的地址": "Please enter your address",
  "请输入您的联系电话": "Please enter your contact phone number",
  "请输入您的联系邮箱": "Please enter your contact email",
  "联系邮箱": "Contact Email",
  "不能全是空格": "Cannot be all spaces",
  "不能包含空格": "Cannot contain spaces",
  "长度不能小于6位": "Length cannot be less than 6 characters",
  "请填写确认密码": "Please fill in the confirmation password",
  "确认密码不一致": "Passwords do not match",
  "联系电话和联系邮箱至少填写一个": "Please provide at least one contact phone number or email",
  "注册成功,请前往登录": "Registration successful, please proceed to log in",
  "清空": "Clear",
  "确认": "Confirm",
  "限时免费": "Limited Time Free",
  // ==================== Components end     =========


  // ==================== 其它  start  ================
  '菜品总量': 'Total dishes',
  '菜品排行榜': 'Dish leaderboard',
  '商家信息': 'Business information',
  '与店内营业时间相同': 'Same as indoor business hours',
  '菜品': 'Dish',
  '菜品分类': 'Dish category',
  '添加菜品': 'Add dish',
  '通告': 'Notice',
  '商家店名': 'Business name',
  '请输入商家店名': 'Please enter the business name',
  '温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱': 'Friendly Reminder: After selection, please do not modify at will to avoid causing disorder in store dish data',
  '网址后缀设置': 'URL suffix setting',
  '选填，设置后缀可替换下列网址末尾的数字id，方便记忆': 'Optional, setting a suffix can replace the numerical ID at the end of the following URLs, making it easier to remember',
  '网址设置': 'URL setting',
  '手机网站二维码': 'Mobile website QR code',
  '按菜品收费': 'Charges per dish',
  '外卖菜品': 'Takeout dishes',
  '店内菜品': 'In-house dishes',
  '菜品管理': 'Dish management',
  '菜品名称': 'Dish name',
  '请输入菜品名称': 'Please enter the dish name',
  '此菜品正在参加活动，不能修改规格': 'This dish is participating in an activity and cannot have its specifications modified',
  '通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。': 'Through artificial intelligence technology, detailed dish information such as ingredients, selling points, and flavors can be automatically filled in based on the dish name.',
  '请填写菜品详情': 'Please fill in the dish details',
  '菜品详情': 'Dish details',
  '菜品图片': 'Dish image',
  '请上传菜品图片': 'Please upload the dish image',
  'AI未识别到您的菜品图片': 'AI did not recognize your dish image',
  '本菜品正在参加活动，不能删除规格！': 'This dish is participating in an activity and cannot have its specifications deleted!',
  '菜品加料': 'Dish ingredients',
  '菜品状态': 'Dish status',
  '选择菜品状态': 'Select dish status',
  '菜品排序': 'Dish sorting',
  '请填写菜品名称': 'Please fill in the dish name',
  '你选择菜品分类': 'You selected the dish category',
  '菜品卖点': 'Dish selling point',
  '菜品属性': 'Dish attributes',
  '菜品同步': 'Dish synchronization',
  '是否同步菜品至外卖': 'Whether to synchronize dishes to takeaway',
  '是否同步菜品至店内': 'Whether to synchronize dishes to in-house',
  '搜索菜品': 'Search for dishes',
  '菜品原价': 'Original price of the dish',
  '菜品来源': 'Dish source',
  '菜品列表': 'Dish list',
  '菜品价格': 'Dish price',
  '菜品销量': 'Dish sales volume',
  '通告管理': 'Notice management',
  '添加通告': 'Add notice',
  '通告ID': 'Notice ID',
  '通告标题': 'Notice title',
  '通告分类': 'Notice category',
  '通告排序': 'Notice sorting',
  '通告状态': 'Notice status',
  '通告内容': 'Notice content',
  '编辑通告': 'Edit notice',
  'AI助理形象选择': 'AI assistant image selection',
  '菜品信息': 'Dish information',
  '菜品总价': 'Total price of dishes',
  '请按实际店名填写，将显示在商家点餐网站上': "Please fill in according to the actual business name, it will be displayed on the business's ordering website",
  '首次添加桌位请先添加桌位类型': 'Please add table types before adding tables for the first time',
  '首次添加桌位请先添加区域': 'Please add regions before adding tables for the first time',
  '设置店内区域，如A区、B区、大厅、包厢等': 'Set indoor areas, such as Zone A, Zone B, Main Hall, Private Rooms, etc.',
  '设置桌位类型，如二人桌、四人桌、大桌、小桌等': 'Set table types, such as two-seater, four-seater, large table, small table, etc.',
  '该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）': 'This account is used to log in to the cashier website (you can find the cashier website URL on the "URL settings" page)',
  '该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）': 'This account is used to log in to the kitchen website (you can find the kitchen website URL on the "URL settings" page)',
  '如无需设置税率可不填写': 'If tax rate setting is not required, it can be left blank',
  '打款信息': 'Payment information',
  '开户行': 'Bank name',
  '菜品分组': 'Dish grouping',
  '自定义名称，仅用于商家自己区分分类，不会展示给顾客': 'Custom name, used only for internal classification by the merchant and will not be shown to customers',
  '手机网站编辑': 'Mobile website editing',
  '恢复初始默认页面': 'Restore the initial default page',
  '通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上': 'Notices are notifications, announcements, business introductions, etc. displayed on the mobile website; when in "display" status, the notice will be shown on the mobile website',
  '菜品重量': 'Dish weight',
  '请填写菜品重量': 'Please fill in the dish weight',
  '菜品设置': 'Dish settings',
  '已选择该菜品': 'You have selected this dish',
  '添加外卖菜品': 'Add takeaway dishes',
  '添加店内菜品': 'Add in-house dishes',
  '购买指定菜品成为分销商': 'Purchase designated dishes to become a distributor',
  '购买指定菜品付款后自动成为分销商，无需后台审核': 'Automatically become a distributor after purchasing designated dishes, without the need for backend approval',
  '选择菜品': 'Select dishes',
  '如开启，分销商自己购买菜品，获得一级佣金': 'If enabled, distributors can purchase dishes themselves and earn first-level commission',
  '订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)”': 'Order payment amount (100.00€) * Points reward ratio (100%) = Actual points awarded (100 points)"',
  '菜品概况': 'Dish overview',
  '菜品统计': 'Dish statistics',
  '在售菜品': 'Dishes for sale',
  '已付款菜品': 'Already paid dishes',
  '菜品总数': 'Total number of dishes',
  '已上架菜品': 'Dishes already on the menu',
  '已下架菜品': 'Dishes already off the menu',
  '菜品导出': 'Export dishes',
  '菜品总销量': 'Total sales volume of dishes',
  '菜品总销售额': 'Total sales revenue of dishes',
  '菜品ID': 'Dish ID',
  '菜品编码': 'Dish code',
  '菜品收藏数': 'Number of dish favorites',
  '请至少选择一件产品菜品！': 'Please select at least one product dish!',
  "区域管理": "Area Management",
  "点餐管理系统": "Ordering Management System",
  "首页": "Homepage",
  "在地图中点击确认位置，坐标自动填入":"Click to confirm the location on the map, and the coordinates will be automatically filled in.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"To add a coupon, please go to 'Marketing'-'Marketing Tools'-'Coupon'",
  // ==================== 其它  end    ================
  ...enLocale
}


export default en



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js